import { AmplitudeEvents, sendAmplitudeEvent } from '@repo/analytics/amplitude/utils'
import { IconButton } from 'primitives/buttons/icon-button'
import * as Dialog from 'primitives/dialog'
import { XCloseIcon } from 'primitives/icons'

import { usePaymentsDialogContext } from '../context/payments-dialog-context'

export const CF_PAYMENTS_MODAL_CLOSED_EVENT_NAME = 'cf_payments_modal_closed'

export function CloseButton() {
  const { customMessages } = usePaymentsDialogContext()

  return (
    <Dialog.Close asChild>
      <IconButton
        onClick={() => {
          sendAmplitudeEvent(AmplitudeEvents.CLOSED_PAYMENT_MODAL)
          if (customMessages) {
            const event = new CustomEvent<{
              message: string
            }>(CF_PAYMENTS_MODAL_CLOSED_EVENT_NAME, {
              detail: {
                message: customMessages,
              },
            })

            document.dispatchEvent(event)
          }
        }}
        variant="violet"
        className="transition-transform hover:scale-110 active:scale-100"
      >
        <img
          src={XCloseIcon.src}
          width="10"
          height="10"
          className="h-[16px] w-[16px] [filter:invert(1)]"
        />
      </IconButton>
    </Dialog.Close>
  )
}
